if (!customElements.get('read-more')) {
  class ReadMore extends HTMLElement {
    connectedCallback() {
      this.updateVisibility();
    }

    updateVisibility() {
      const targetElement = this.querySelector('[data-collapsible-target]');
      const triggerElement = this.querySelector('[data-collapsible-trigger]');

      if (targetElement && triggerElement) {
        if (targetElement.scrollHeight > targetElement.clientHeight) {
          triggerElement.classList.remove('hidden');
          this.closest('[data-collapsible-group]')?.classList.remove('read-more-is-open');
        } else {
          triggerElement.classList.add('hidden');
          this.closest('[data-collapsible-group]')?.classList.add('read-more-is-open');
        }
      }
    }
  }

  window.ReadMore = ReadMore;

  customElements.define('read-more', ReadMore);
}
